import type { TodoId } from "@common/types/todo";

const uuid = require("uuid");

export interface Note {
  id: string;
  content: string;
  owner: string | null;
  todoId: TodoId | null; // not every note must belong to a todo
  createdDate: number;
  lastEditDate: number;
}

export type UpdateNotePayload = Omit<Note, "lastEditDate" | "createdDate">;

export function makeNote({
  id = uuid.v4(),
  content = "",
  owner,
  todoId = null,
  createdDate = Date.now(),
  lastEditDate = Date.now(),
}: Partial<Note> & Pick<Note, "owner">): Note {
  return {
    id,
    content,
    owner,
    todoId,
    createdDate,
    lastEditDate,
  };
}

export function validateNote({
  id,
  content,
  owner,
  todoId,
  createdDate,
  lastEditDate,
}: Note): Note {
  if (!id || content === undefined || !owner) {
    throw "invalid note";
  }
  return {
    id,
    content,
    owner,
    todoId,
    createdDate,
    lastEditDate,
  };
}
